
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import "./TopCashbackStores.css";
import Footer from "./Footer";
import Manubar from "./Manubar";
import { ToastContainer } from "react-toastify";
import StoreOfferCard from "./StoreOfferCard";

const sortTabs = ["Popularity", "A-Z", "Percent", "Amount", "Newest"];

const TopCashbackStores = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeSort = searchParams.get("sortby") || "Popularity";
  const activeCategory = searchParams.get("category") || "All";

  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchStores = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/stores_by_category?category=${activeCategory}`
      );
      if (data?.success) {
        let list = data.data;

        if (activeSort === "A-Z") {
          list.sort((a, b) => a.name.localeCompare(b.name));
        } else if (activeSort === "Newest") {
          list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        }
        // Percent/Amount sort chaho to user_cashback_percent field se kar sakte ho

        setBrands(list);
      } else {
        setBrands([]);
      }
    } catch (error) {
      console.log(error);
      setBrands([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSort, activeCategory]);

  const handleSortClick = (tab) => {
    const params = Object.fromEntries(searchParams);
    setSearchParams({ ...params, sortby: tab });
  };

  const handleCardClick = (item) => {
    navigate(`/stores/${item.slug}`);
  };

  return (
    <>
      <ToastContainer position="top-center" />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <nav className="breadcrumb-section">
        <div className="container">
          <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {activeCategory !== "All" ? activeCategory : "Top Cashback Stores"}
            </li>
          </ol>
        </div>
      </nav>

      <section className="cashback-stores-page">
        <div className="container">
          <h2 className="page-title">
            {activeCategory !== "All" ? activeCategory.replace(/-/g, " ") : "Top Cashback Stores"}
          </h2>

          <div className="sort-tabs">
            {sortTabs.map((tab) => (
              <button
                key={tab}
                className={`sort-tab ${activeSort === tab ? "active" : ""}`}
                onClick={() => handleSortClick(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {loading && <p className="loading-text">Loading...</p>}

          {!loading && brands.length === 0 && (
            <p className="loading-text">No brands available in this category.</p>
          )}

          {!loading && brands.length > 0 && (
            <div className="brands-grid">
              {brands.map((item) => (
  <StoreOfferCard
    key={item._id}
    item={item}
    onClick={() => handleCardClick(item)}
  />
))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default TopCashbackStores;